import React, { Fragment, useEffect, useState } from 'react';
import { Btn, H4, H6, Image, LI, P, UL } from '../../../../AbstractElements';
import { ProductDetails } from '../../../../Constant';
import { Modal, Col } from 'reactstrap';

const ProductModal = (props) => {
  const [open, setOpen] = useState(props.value);
  const [singleBanner, setSingleBanner] = useState(null);

  useEffect(() => {
    // Find banner by ID
    if (props.dataid && props.dataid.toString().startsWith('banner-')) {
      const bannerId = props.dataid.replace('banner-', '');
      const banner = props.banners?.find(b => b.id?.toString() === bannerId || b.id?.toString() === bannerId.split('-')[0]);
      if (banner) {
        setSingleBanner(banner);
      }
    }
  }, [props.dataid, props.banners]);

  const onCloseModal = () => {
    setOpen(false);
    props.setOpenModal(false);
  };

  return (
    <Fragment>
      <Modal className='modal-dialog modal-lg modal-dialog-centered product-modal' isOpen={open}>
        <div className='modal-body'>
          <div className='modal-header'>
            <div className='modal-title'>
              <div className='product-box row'>
                <Col lg='6'>
                  <Image
                    attrImage={{
                      className: 'img-fluid',
                      src: singleBanner ? singleBanner.url : '',
                      alt: singleBanner ? singleBanner.filename || 'Banner' : '',
                      onError: (e) => {
                        e.target.src = '/src/assets/images/dashboard/profile.png';
                      }
                    }}
                  />
                </Col>
                <Col lg='6' className='product-details text-start'>
                  <H4>{singleBanner ? `Banner ${singleBanner.filename || `#${singleBanner.id}`}` : 'Banner Details'}</H4>
                  <div className='product-price'>
                    <span className="text-success">API Banner</span>
                  </div>
                  <div className='product-view'>
                    <H6 attrH6={{ className: 'f-w-600' }}>Banner Information</H6>
                    <P attrPara={{ className: 'mb-0' }}>
                      {singleBanner ? (
                        <div>
                          <strong>Banner ID:</strong> {singleBanner.id || 'N/A'}<br/>
                          <strong>Filename:</strong> {singleBanner.filename || 'N/A'}<br/>
                          <strong>Size:</strong> {(singleBanner.size / 1024).toFixed(1)} KB<br/>
                          <strong>Type:</strong> {singleBanner.mimetype || 'N/A'}<br/>
                          <strong>Created:</strong> {singleBanner.createdAt ? new Date(singleBanner.createdAt).toLocaleDateString() : 'N/A'}<br/>
                          <strong>Updated:</strong> {singleBanner.updatedAt ? new Date(singleBanner.updatedAt).toLocaleDateString() : 'N/A'}
                        </div>
                      ) : 'No banner data available'}
                    </P>
                  </div>
                  {singleBanner && (
                    <div className='addcart-btn'>
                      <div className='btn btn-info me-3'>
                        <i className='fa fa-image me-1'></i>
                        Banner #{singleBanner.id || 'N/A'}
                      </div>
                      <div className='btn btn-secondary me-3'>
                        <i className='fa fa-file-o me-1'></i>
                        {(singleBanner.size / 1024).toFixed(1)} KB
                      </div>
                      <div className='btn btn-success'>
                        <i className='fa fa-external-link me-1'></i>
                        <a href={singleBanner.url} target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">
                          View Full Size
                        </a>
                      </div>
                    </div>
                  )}
                </Col>
              </div>
            </div>
            <Btn attrBtn={{ color: 'transprant', className: 'btn-close', onClick: onCloseModal, type: 'button', databsdismiss: 'modal', arialabel: 'Close' }}></Btn>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};
export default ProductModal;
